
import { Link } from 'react-router-dom';

interface Article {
  id: string;
  title: string;
  category: string;
  source: string;
  timeAgo: string;
  image: string;
  excerpt: string;
}

export default function RelatedStories({ articles, currentId }: { articles: Article[]; currentId: string }) {
  const related = articles
    .filter((a) => a.id !== currentId)
    .slice(0, 4);

  if (related.length === 0) return null;

  return (
    <section className="py-16 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">Related Stories</h2>
            <p className="text-gray-500 text-sm mt-1">More news from Roseville</p>
          </div>
          <Link
            to="/news"
            className="inline-flex items-center gap-2 text-teal-600 font-semibold text-sm hover:text-teal-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            View All News
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {related.map((article) => (
            <Link
              key={article.id}
              to={`/news/${article.id}`}
              className="group bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-all border border-gray-100 cursor-pointer"
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-[11px] text-gray-400">{article.timeAgo}</span>
                </div>
                <h3 className="text-sm font-bold text-gray-900 line-clamp-2 group-hover:text-teal-600 transition-colors leading-snug">
                  {article.title}
                </h3>
                <span className="text-[11px] text-teal-600 font-semibold uppercase mt-2 block">{article.category}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
